import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import {
  useHistory,
  Switch,
  Route,
  useRouteMatch
} from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';
import { wgw as wgwItemResults } from '../../redux/actions';
import apis from '../../app/apis';
import cts from '../../app/cts';

/**
 * Sections
 */
import List from './sections/List';
import Group from './sections/Group';
import SearchResults from './sections/SearchResults';
import NotFound from './sections/NotFound';


/**
 * Components
 */
import Searchbox from './components/SearchBox/Searchbox';

// const { setWgwResults } = wgw;

const WhatGoesWhere = ({ localityId, setItemResults }) => {
  const [isSearch, setIsSearch] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [temp, setTemp] = useState('');
  const { path } = useRouteMatch();
  const history = useHistory();


  const getGroup = async (id) => {
    try {
      const { data, status } = await cts('get', apis.materialsByGroupId(localityId, id));
      setIsSearch(!isSearch);
      if (status !== 200 && !data) {
        throw new Error('Error fetching data');
      }
      if (!(Array.isArray(data.content.results) && data.content.results.length)) {
        setTemp('empty');
      }
      setSearchResults(data.content.mats.map((mat) => ({ name: mat.mat_nm, id: mat.mat_id })));
    } catch (e) {
      console.log('Error! Getting material group', e);
      setSearchResults([]);
    }
  };

  const fetchResult = async (term) => {
    try {
      const { data, status } = await cts('get', apis.searchMaterialByTerm(localityId, term));
      if (status !== 200 && !data) {
        throw new Error('Error fetching data');
      }
      setSearchResults(data.content.results);
      notFound(data.content.results);
    } catch (e) {
      if (axios.isCancel(e)) {
        setSearchResults([]);
        setSearchTerm('');
      }
    } finally {
      setLoading(false);
    }
  };

  /**
   * Fix race condition problem
   * @param {string} term
   */
  const [debouncedFetchResult] = useDebouncedCallback(
    fetchResult,
    1000
  );

  /**
   * Material name to search
   *
   * @param {string} term
   */
  const search = async (term) => {
    setTemp('');
    setSearchTerm(term);
    setSearchResults([]);
    if (!term) {
      setIsSearch(false);
      setSearchResults([]);
    } else {
      setIsSearch(true);
      setLoading(true);
      debouncedFetchResult(term);
    }
  };

  const notFound = (e) => {
    if (!e.length) {
      setTemp('empty');
    }
  };


  /**
   * Navigate to material details page
   *
   * @param {number} materialId
   */
  const MaterialClickHandler = (materialId) => {
    history.push('/material-details', { id: materialId });
  };

  useEffect(() => {
    if (searchResults.length) {
      setItemResults(searchResults);
    }
  }, [searchResults]);

  useEffect(() => {
    /**
     * Clear the Redux state
     */
    if (
      !searchResults.length
      && history.location.pathname === '/wgw'
    ) {
      setItemResults([]);
    }
  }, [searchResults]);

  const renderPage = () => {
    if (
      !searchResults.length
      && !searchTerm
    ) {
      return (
        <Switch>
          <Route
            path={`${path}/list`}
            exact
            key={() => Math.random()}
            render={() => (
              <List
                onClick={MaterialClickHandler}
              />
            )}
          />
          <Route
            path={`${path}/search`}
            exact
            key={() => Math.random()}
            render={() => (
              <SearchResults
                loading={loading}
                onClick={MaterialClickHandler}
              />
            )}
          />
          <Route
            path={path}
            exact
            key={() => Math.random()}
            render={() => (
              <Group
                onClick={getGroup}
              />
            )}
          />
        </Switch>
      );
    }
    // It's search
    return (
      <SearchResults
        loading={loading}
        onClick={MaterialClickHandler}
      />
    );
  };

  return (
    <div>
      <Searchbox
        term={searchTerm}
        onSearch={(term) => search(term)}
        cancelSearch={() => setIsSearch(false)}
      />
      {
        searchTerm
        && !searchResults.length
        && temp === 'empty' ? (
          <NotFound />
          ) : null
      }

      {
        renderPage()
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  localityId: state.app.localityId,
});

const mapDispatchToProps = (dispatch) => ({
  setItemResults: (value) => dispatch(wgwItemResults(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WhatGoesWhere);
